import { useCallback, useContext } from 'react';
import { FilterGroupContext } from 'components/filter/filters-next/FilterGroupContext';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { FilterGroup } from 'components/filter/types';
import { cloneDeep } from 'lodash';
import { v4 as uuid } from 'uuid';

const useGetMutableValues = () => {
    const { cacheKey } = useContext(FilterProviderContext);
    const { groupId, defaultOperator } = useContext(FilterGroupContext);
    const { currentGroup } = useFiltersByKey(cacheKey, groupId, defaultOperator);
    return useCallback(() => {
        return currentGroup
            ? cloneDeep(currentGroup)
            : ({
                  id: uuid(),
                  innerOperator: defaultOperator,
                  outerOperator: defaultOperator,
                  filters: [],
              } as FilterGroup);
    }, [currentGroup, defaultOperator]);
};

export { useGetMutableValues };
